import React from 'react';

const Home = () => {
  return (
    <>
      <h1>Selamat datang</h1>
      <p>Cek menu sebelah kiri</p>
    </>
  );
};

export default Home;
